import { useReducedMotion } from "motion/react";
import { useRecoilValue } from "recoil";

import { isFullscreenOverlayVisibleAtom } from "@ryde/shared";

export const useDashboardGridAppear = (isLayoutResolved: boolean): boolean => {
  const shouldReduceMotion = useReducedMotion();
  const isOverlayVisible = useRecoilValue(isFullscreenOverlayVisibleAtom);

  if (shouldReduceMotion) {
    return true;
  }

  return isLayoutResolved && !isOverlayVisible;
};
